import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { PropTypes } from 'prop-types';

import ChecklistItem from './ChecklistItem';

export default class ChecklistItems extends PureComponent {
  static defaultProps = {
    text: 'module_editor.select_all',
    items: []
  };

  static propTypes = {
    checklistId: PropTypes.string,
    items: PropTypes.array,
    selectedLimit: PropTypes.number,
    text: PropTypes.string
  };

  get isSelectedLimitReached() {
    const { items, selectedLimit } = this.props;
    const checkedItems = items.filter((item) => item.checked);

    return checkedItems.length >= selectedLimit;
  }

  isDisabled(item) {
    return this.isSelectedLimitReached && !item.checked;
  }

  render() {
    const { items, checklistId } = this.props;

    return items.map((item, index) => {
      const key = `checklist__${checklistId}__item__${index}`;
      const isDisabled = item.disabled || this.isDisabled(item);
      const classComponent = classNames({
        'checklist__item--disabled': isDisabled
      });

      return (
        <ChecklistItem
          {...this.props}
          id={key}
          key={key}
          item={item}
          disabled={isDisabled}
          className={classComponent}
        />
      );
    });
  }
}
